import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { ModuleType, TokenType, type IToken } from "@framework/types";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { TokenSearchForm } from "../../../components/forms/token-search";
import { MyTokenListItem } from "./item";

export interface IMyTokenListProps {
  embedded?: boolean;
}

export const MyTokensList = (props: IMyTokenListProps) => {
  const { embedded } = props;

  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IToken>
  >("/tokens/search", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "tokens"]} isHidden={embedded} />

      <PageHeader message="pages.tokens.title" />

      <TokenSearchForm
        contractType={[TokenType.ERC721, TokenType.ERC998, TokenType.ERC1155]}
        contractModule={[
          ModuleType.HIERARCHY,
          ModuleType.MYSTERY,
          ModuleType.LOOT,
          ModuleType.COLLECTION,
          ModuleType.LOTTERY,
          ModuleType.RAFFLE,
          ModuleType.WRAPPER,
        ]}
      />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(token => (
              <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={token.id}>
                <MyTokenListItem token={token} />
              </Grid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
